import { MGPOptional } from '@everyboard/lib';
import { BooleanConfig } from '../../../config/BooleanConfig';
import { NumberConfig } from '../../../config/NumberConfig';
import { RulesConfigDescription } from '../../../config/RulesConfigDescription';
import { RulesConfigDescriptionLocalizable } from '../../../config/RulesConfigDescriptionLocalizable';
import { Coord } from '../../../jscaip/Coord';
import { TableUtils } from '../../../jscaip/TableUtils';
import { MGPValidators } from '../../../utils/MGPValidator';
import { MancalaRules } from '../common/MancalaRules';
export class KalahRules extends MancalaRules {
    static singleton = MGPOptional.empty();
    static RULES_CONFIG_DESCRIPTION = new RulesConfigDescription({
        name: () => $localize `Kalah`,
        config: {
            feedOriginalHouse: new BooleanConfig(true, MancalaRules.FEED_ORIGINAL_HOUSE),
            mustFeed: new BooleanConfig(false, MancalaRules.MUST_FEED),
            passByPlayerStore: new BooleanConfig(true, MancalaRules.PASS_BY_PLAYER_STORE),
            mustContinueDistributionAfterStore: new BooleanConfig(true, MancalaRules.MULTIPLE_SOW),
            continueLapUntilCaptureOrEmptyHouse: new BooleanConfig(false, MancalaRules.CYCLICAL_LAP),
            seedsByHouse: new NumberConfig(4, MancalaRules.SEEDS_BY_HOUSE, MGPValidators.range(1, 99)),
            width: new NumberConfig(6, RulesConfigDescriptionLocalizable.WIDTH, MGPValidators.range(1, 99)),
            numberOfRows: new NumberConfig(1, MancalaRules.NUMBER_OF_ROWS, MGPValidators.range(1, 99)),
        },
    });
    static get() {
        if (KalahRules.singleton.isAbsent()) {
            KalahRules.singleton = MGPOptional.of(new KalahRules([]));
        }
        return KalahRules.singleton.get();
    }
    getRulesConfigDescription() {
        return KalahRules.RULES_CONFIG_DESCRIPTION;
    }
    applyCapture(distributionResult, config) {
        const distributedState = distributionResult.resultingState;
        const capturelessResult = {
            capturedSum: 0,
            captureMap: TableUtils.create(distributedState.getWidth(), distributedState.getHeight(), 0),
            resultingState: distributedState,
        };
        if (distributionResult.endsUpInStore) {
            return capturelessResult;
        }
        else {
            const landingSpace = distributionResult.filledCoords[distributionResult.filledCoords.length - 1];
            const currentPlayer = distributionResult.resultingState.getCurrentPlayer();
            const oppositeY = this.getOppositeY(landingSpace, config);
            const landingSeeds = distributionResult.resultingState.getPieceAt(landingSpace);
            const parallelSeeds = distributionResult.resultingState.getPieceAtXY(landingSpace.x, oppositeY);
            if (this.getSpaceOwner(landingSpace, config) === currentPlayer && landingSeeds === 1 && parallelSeeds > 0) {
                // We can capture
                const board = distributedState.getCopiedBoard();
                const capturedSum = board[0][landingSpace.x] + board[1][landingSpace.x];
                const captureMap = TableUtils.create(distributedState.getWidth(), distributedState.getHeight(), 0);
                captureMap[landingSpace.y][landingSpace.x] = board[landingSpace.y][landingSpace.x];
                captureMap[oppositeY][landingSpace.x] = board[oppositeY][landingSpace.x];
                const capturer = distributedState.getCurrentPlayer();
                let postCaptureState = distributedState.capture(capturer, landingSpace);
                const oppositeSpace = new Coord(landingSpace.x, oppositeY);
                postCaptureState = postCaptureState.capture(capturer, oppositeSpace);
                return {
                    capturedSum, captureMap, resultingState: postCaptureState,
                };
            }
            else {
                return capturelessResult;
            }
        }
    }
}
